import React from 'react';

const Logo: React.FC = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H64C68.4183 0 72 3.58172 72 8V64C72 68.4183 68.4183 72 64 72H8C3.58172 72 0 68.4183 0 64V8Z"
        fill="#8BBC07"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.2387 24.2852L63.7914 15L40.2387 24.2852Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.9086 14.1644C66.3695 15.3337 65.7953 16.6553 64.626 17.1163L41.0734 26.4015C39.9041 26.8624 38.5825 26.2882 38.1215 25.1189C37.6605 23.9496 38.2347 22.628 39.404 22.167L62.9567 12.8819C64.126 12.4209 65.4476 12.9951 65.9086 14.1644Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.9557 31.4066L62.066 31.3887L40.9557 31.4066Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.3418 31.3871C64.3429 32.644 63.3249 33.6638 62.068 33.6649L40.9577 33.6828C39.7008 33.6839 38.681 32.6658 38.6799 31.4089C38.6789 30.1521 39.6969 29.1323 40.9538 29.1312L62.0641 29.1133C63.321 29.1122 64.3408 30.1303 64.3418 31.3871Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.0305 38.25L53.7509 45.2705L39.0305 38.25Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9763 37.2693C37.5174 36.1348 38.8757 35.6538 40.0101 36.1948L54.7306 43.2153C55.865 43.7564 56.3461 45.1147 55.805 46.2492C55.264 47.3836 53.9057 47.8647 52.7712 47.3236L38.0508 40.3031C36.9163 39.7621 36.4353 38.4038 36.9763 37.2693Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8029 43.7598L42.8803 53.4224L34.8029 43.7598Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3433 42.0142C34.3077 41.208 35.7429 41.3363 36.549 42.3006L44.6264 51.9632C45.4325 52.9276 45.3042 54.3628 44.3399 55.1689C43.3756 55.9751 41.9403 55.8468 41.1342 54.8825L33.0569 45.2198C32.2507 44.2555 32.379 42.8203 33.3433 42.0142Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.991 47.3457L31.1424 55.4985L28.991 47.3457Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4103 45.1462C29.6256 44.8255 30.8708 45.5507 31.1915 46.766L33.3429 54.9188C33.6636 56.1341 32.9384 57.3793 31.7231 57.7C30.5078 58.0207 29.2627 57.2955 28.942 56.0802L26.7905 47.9274C26.4698 46.7121 27.195 45.4669 28.4103 45.1462Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4418 48.8184L21.8756 53.1212L22.4418 48.8184Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7387 46.5607C23.9848 46.7247 24.8621 47.8678 24.6981 49.114L24.132 53.4168C23.968 54.663 22.8249 55.5403 21.5787 55.3763C20.3326 55.2123 19.4553 54.0692 19.6192 52.8231L20.1854 48.5202C20.3494 47.274 21.4925 46.3968 22.7387 46.5607Z"
        fill="white"
      />
      <path
        d="M18.3313 47.844C18.3314 48.1613 18.269 48.4755 18.1476 48.7686C18.0262 49.0618 17.8483 49.3281 17.624 49.5525C17.3997 49.7769 17.1333 49.9549 16.8402 50.0763C16.5471 50.1977 16.2329 50.2602 15.9156 50.2602C15.5984 50.2602 15.2842 50.1977 14.9911 50.0763C14.698 49.9549 14.4316 49.7769 14.2073 49.5525C13.983 49.3281 13.8051 49.0618 13.6837 48.7686C13.5623 48.4755 13.4999 48.1613 13.5 47.844C13.4999 47.5267 13.5623 47.2125 13.6837 46.9194C13.8051 46.6262 13.983 46.3599 14.2073 46.1355C14.4316 45.9111 14.698 45.7331 14.9911 45.6117C15.2842 45.4902 15.5984 45.4277 15.9156 45.4277C16.2329 45.4277 16.5471 45.4902 16.8402 45.6117C17.1333 45.7331 17.3997 45.9111 17.624 46.1355C17.8483 46.3599 18.0262 46.6262 18.1476 46.9194C18.269 47.2125 18.3314 47.5267 18.3313 47.844Z"
        fill="white"
      />
    </svg>
  );
};

export default Logo;
